import * as React from 'react';
import {DropdownMenu} from '@liveoptics/react-ui';

const Region = ({regions, onRegionSelect, selectedRegion}) => {
    return (
        <>
            <DropdownMenu defaultValue="" placeholder='Select a region' onChange={(e) => {onRegionSelect(e.currentTarget.value)}} style={{maxWidth: '100%'}}>
                <option value="">Select a region</option>
                {
                    regions.map((region) => {
                        return <option key={region.key} value={region.key}>{region.title}</option>
                    })
                }
            </DropdownMenu>
        </>
    )
}

export default Region;